const SECURE_FIREWALL_DOMAINS_BEHAVIOR =
  'debug.secure-firewall-domains-behavior';

export const DebugSecureFirewallCheck = {
  SECURE_FIREWALL_DOMAINS_BEHAVIOR,
  getDebugFirewallCheckDomainsBehavior: () => {
    const domainBehaviors = window.localStorage.getItem(
      SECURE_FIREWALL_DOMAINS_BEHAVIOR,
    );
    if (domainBehaviors === null) return {};
    return JSON.parse(domainBehaviors);
  },
  areDebugKeysSetInLocalStorage: () => {
    // debugging is disabled in production
    if (process.env.ENV === 'prod') return false;

    return !!localStorage.getItem(SECURE_FIREWALL_DOMAINS_BEHAVIOR);
  },
};

export const removeDebugKeysFromLocalStorage = () => {
  window.localStorage.removeItem(SECURE_FIREWALL_DOMAINS_BEHAVIOR);
};
